import * as yup from "yup";

export const cropUpdateInfoSchema = yup.object().shape({
  cropName: yup.string().required("Required"),
  cropCycleName: yup.string().required("Required"),
  typeOfSystem: yup.string().required("Required"),
  ceaSystem: yup.string(),
  waterTankCapacity: yup.string(),
  cropCycleStartDate: yup.string().required("Required"),
  totalCropCount: yup.string(),
  cropPhoto: yup.array(),
});
